import { HTTPURL } from "../../constants/Matcher";

// Branch-scoped calendar — every class in this branch within [from, to],
// expanded by week, plus relevant events.
export async function get_branch_calendar({ branch_id, from, to }) {
  try {
    const url = `${HTTPURL}api/branches/class-calendar?branch_id=${branch_id}&from=${from}&to=${to}`;
    const res = await fetch(url);
    const data = await res.json();
    return data;
  } catch (error) {
    console.log(error.message);
    return { status: false, message: error.message, data: { lessons: [], events: [] } };
  }
}
